import { WihAction } from "../wih/WihAction.model";
import { FormAction } from "./FormAction.model";


/**
 * 어플리케이션 폼 스테이트에서 사용되는 키 정의
 * @since 0.0.1
 * @author Heungsoo Ham
 * @enum
 */
export enum FormStateKey {
    SELECTEDPROJECT = "selectedProject",
    CLICKEDPROJECT = "clickedProject",
    SELECTEDFORM = "selectedForm",
    SELECTEDPAGE = "selectedPage",
    SELECTEDCOMPONENTELEMENT = "selectedComponentElement",
    SELECTEDDATASCHEMAFIELD = "selectedDataSchemaField",
    SELECTEDDATASCHEMAGROUP = "selectedDataSchemaGroup",
    SELECTEDDATASCHEMARELATIONSHIP = "selectedDataSchemaRelationship",
    SELECTEDEMBEDFORM = "selectedEmbedForm",
    SELECTEDEMBEDPAGE = "selectedEmbedPage",
    SELECTEDFORMDESIGNER = "selectedFormDesigner",
    SELECTEDPREFORMDESIGNER = "selectedPreFormDesigner",
    SELECTEDCHECKFORMDESIGNER = "selectedCheckFormDesigner",
    SELECTEDGRIDFORCONTAINER = "selectedGridForContainer",
    FROMFORMSCHEMA = "fromFormSchema",
    CHANGEDATASCHEMAFIELD = "changeDataSchemaField",
    CHANGECOMPONENTFIELD = "changeComponentField",
    OPENDATAMODELER = "openDataModeler",
    OPENPROJECTMANAGER = "openProjectManager",
    OPENPROJECTDOCUMENTATION = "openProjectDocumentation",
    OPENPROJECTPUBLISH = "openProjectPublish",
    OPENPUBLISHHISTORY = "openPublishHistory",
    OPENFORMCALLBACK = "openFormCallback",
    OPENMODALCALLBACK = "openModalCallback",
    OPENFORMREDOUNDO = "openFormRedoUndo",
    OPENFORMVERSIONING = "openFormVersioning",
    OPENDATAMODELERVERSIONING = "openDataModelerVersioning",
    OPENSCHEMAVERSIONING = "openSchemaVersioning",
    OPENONLINEDOCUMENTS = "openOnlineDocuments",
    OPENABOUT = "openAbout",
    CLOSEDESIGNPANEL = "closeDesignPanel",
    LEFTMENUMODE = "leftMenuMode",
    WIHACTION = "wihAction",
    FORMACTION = "formAction",
    GRIDACTION = "gridAction",
    LINKFORM = "linkForm",
    PROJECTPUBLISHPROCESSING = "projectPublishProcessing",
    PROJECTPUBLISHONLYVALIDATION = "projectPublishOnlyValidation",
    PROJECTPUBLISHONLYPUBLISH = "projectPublishOnlyPublish",
    PROJECTPUBLISHCLOSE = "projectPublishClose",
    PROJECTPUBLISHFORCE = "projectPublishForce",
    CLICKEDONLYPUBLISH = "clickedOnlyPublish",
    PUBLISHHISTORYOVERWRITE = "publishHistoryOverwrite",
    PUBLICATIONIDFOROVERWRITE = "publicationIdForOverwrite",
    FORMCALLBACKINFO = "formCallbackInfo",
    OPENCUSTOMHTML = "openCustomHtml",
    OPENCUSTOMHTMLAPPLY = "openCustomHtmlApply",
    OPENCUSTOMHTMLCLOSE = "openCustomHtmlClose",
    OPENCUSTOMHTMLREADONLY = "openCustomHtmlReadonly",
    OPENEXTENDCSSANDSCRIPT = "openExtendCssAndScript",
    OPENEXTENDCSSANDSCRIPTAPPLY = "openExtendCssAndScriptApply",
    OPENEXTENDCSSANDSCRIPTCLOSE = "openExtendCssAndScriptClose",
    OPENEXTENDCSSANDSCRIPTREADONLY = "openExtendCssAndScriptReadonly",
    OPENFORMCONFIG = "openFormConfig",
    OPENFORMCONFIGAPPLY = "openFormConfigApply",
    OPENFORMCONFIGCLOSE = "openFormConfigClose",
    OPENFORMCONFIGREADONLY = "openFormConfigReadonly",
    OPENLOOKUPDATAFILTER = "openLookupDataFilter",
    OPENLOOKUPDATAFILTERAPPLY = "openLookupDataFilterApply",
    OPENLOOKUPDATAFILTERCLOSE = "openLookupDataFilterClose",
    OPENLOOKUPDATAFILTERREADONLY = "openLookupDataFilterReadonly",
    OPENLOOKUPDATAFILTERAPI = "openLookupDataFilterAPI",
    OPENGRIDVALIDATION = "openGridValidation",
    OPENGRIDVALIDATIONAPPLY = "openGridValidationApply",
    OPENGRIDVALIDATIONCLOSE = "openGridValidationClose",
    OPENGRIDVALIDATIONREADONLY = "openGridValidationReadonly",
    OPENCUSTOMVALIDATIO = "openCustomValidation",
    TOGGLEVALIDATION = "toggleValidation"
}

/**
 * 사전 정의 된 state, readonly state 구조
 * @since 0.0.1
 * @author Heungsoo Ham
 * @type
 */
export type FormStateStructure = {
    option: {
        accessibility?: boolean;
        userId?: string;
        userName?: string;
        dateFormat?: string;
    };
    state: {
        step: string;
        wihAction: WihAction;
        formAction: FormAction;
    };
    readOnlyState: {
        queryString: {
            [key: string]: any;
        }
    }
}
